import * as Types from '../../network/graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetSellerDac7DataMutationVariables = Types.Exact<{
  input: Types.SetSellerDac7DataInput;
}>;


export type SetSellerDac7DataMutation = { __typename?: 'Mutation', setSellerDac7Data: { __typename?: 'SetSellerDac7DataPayload', ok: boolean } };

export type ValidateSellerDac7DataMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ValidateSellerDac7DataMutation = { __typename?: 'Mutation', validateSellerDac7Data: { __typename?: 'ValidateSellerDac7DataPayload', ok: boolean } };


export const SetSellerDac7DataDocument = gql`
    mutation SetSellerDac7Data($input: SetSellerDac7DataInput!) {
  setSellerDac7Data(input: $input) {
    ok
  }
}
    `;
export type SetSellerDac7DataMutationFn = Apollo.MutationFunction<SetSellerDac7DataMutation, SetSellerDac7DataMutationVariables>;

/**
 * __useSetSellerDac7DataMutation__
 *
 * To run a mutation, you first call `useSetSellerDac7DataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSellerDac7DataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSellerDac7DataMutation, { data, loading, error }] = useSetSellerDac7DataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSellerDac7DataMutation(baseOptions?: Apollo.MutationHookOptions<SetSellerDac7DataMutation, SetSellerDac7DataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSellerDac7DataMutation, SetSellerDac7DataMutationVariables>(SetSellerDac7DataDocument, options);
      }
export type SetSellerDac7DataMutationHookResult = ReturnType<typeof useSetSellerDac7DataMutation>;
export type SetSellerDac7DataMutationResult = Apollo.MutationResult<SetSellerDac7DataMutation>;
export type SetSellerDac7DataMutationOptions = Apollo.BaseMutationOptions<SetSellerDac7DataMutation, SetSellerDac7DataMutationVariables>;
export const ValidateSellerDac7DataDocument = gql`
    mutation ValidateSellerDac7Data {
  validateSellerDac7Data {
    ok
  }
}
    `;
export type ValidateSellerDac7DataMutationFn = Apollo.MutationFunction<ValidateSellerDac7DataMutation, ValidateSellerDac7DataMutationVariables>;

/**
 * __useValidateSellerDac7DataMutation__
 *
 * To run a mutation, you first call `useValidateSellerDac7DataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSellerDac7DataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSellerDac7DataMutation, { data, loading, error }] = useValidateSellerDac7DataMutation({
 *   variables: {
 *   },
 * });
 */
export function useValidateSellerDac7DataMutation(baseOptions?: Apollo.MutationHookOptions<ValidateSellerDac7DataMutation, ValidateSellerDac7DataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateSellerDac7DataMutation, ValidateSellerDac7DataMutationVariables>(ValidateSellerDac7DataDocument, options);
      }
export type ValidateSellerDac7DataMutationHookResult = ReturnType<typeof useValidateSellerDac7DataMutation>;
export type ValidateSellerDac7DataMutationResult = Apollo.MutationResult<ValidateSellerDac7DataMutation>;
export type ValidateSellerDac7DataMutationOptions = Apollo.BaseMutationOptions<ValidateSellerDac7DataMutation, ValidateSellerDac7DataMutationVariables>;